import React from 'react'
import { Control, Controller } from 'react-hook-form'

import { useMediaQuery } from '@mui/material'
import { Box, Stack, Typography, Divider, Tabs, Tab } from '@mui/material'

import { NewExpenseSchema } from 'components/Modal/ModalNewExpense/schema'

import { theme } from 'styles/theme'

interface TypeTabsProps {
  control: Control<NewExpenseSchema, object>
  disabled?: boolean
}

const TypeTabs = ({ control, disabled }: TypeTabsProps) => {
  const isMobile = useMediaQuery('(max-width:940px)')

  return (
    <Box
      display={'flex'}
      flexWrap={'wrap'}
      sx={{
        border: '1px solid #E3E5E3',
        borderRadius: '5px'
      }}
    >
      <Controller
        name="accountsPayableFrequency"
        control={control}
        render={({ field: { onChange, value } }) => (
          <Tabs
            value={Number(value)}
            sx={{
              width: '100%',
              '& .MuiTab-root': {
                opacity: 1,
                color: theme.palette.neutral[600],
                '& .MuiTypography-root.main-text': {
                  fontWeight: 400
                },
                ...(isMobile && {
                  padding: '6px 8px'
                })
              },
              '& .Mui-selected': {
                color: theme.palette.neutral[900],
                '& .MuiTypography-root.main-text': {
                  fontWeight: 600
                }
              },
              '& .Mui-disabled': {
                color: `${theme.palette.neutral[400]} !important`,
                cursor: 'not-allowed',
                '& .MuiTypography-root': {
                  color: theme.palette.neutral[400]
                },
                '&:hover': {
                  backgroundColor: 'transparent'
                }
              }
            }}
            onChange={(_, s) => {
              onChange(s)
            }}
            textColor="inherit"
            indicatorColor="primary"
            aria-label="tabs"
          >
            <Tab
              disabled={disabled}
              sx={{
                minWidth: '50%',
                whiteSpace: 'normal',
                flex: 1
              }}
              value={0}
              label={
                <Stack
                  direction="row"
                  gap="5px"
                  sx={{
                    textAlign: 'center',
                    ...(isMobile && {
                      flexDirection: 'column',
                      gap: '2px'
                    })
                  }}
                >
                  <Typography
                    variant={isMobile ? 'xsLight' : 'smLight'}
                    className="main-text"
                    sx={{ textTransform: 'none' }}
                  >
                    Despesa recorrente
                  </Typography>
                  <Typography
                    fontSize="14px"
                    variant="xsLight"
                    color={theme.palette.neutral[400]}
                    sx={{
                      textTransform: 'none',
                      ...(isMobile && {
                        fontSize: '10px',
                        lineHeight: '12px'
                      })
                    }}
                  >
                    (ocorre todos os meses)
                  </Typography>
                </Stack>
              }
            />
            <Divider orientation="vertical" flexItem />
            <Tab
              disabled={disabled}
              sx={{
                minWidth: '50%',
                whiteSpace: 'normal',
                flex: 1
              }}
              value={1}
              label={
                <Stack
                  direction="row"
                  gap="5px"
                  sx={{
                    textAlign: 'center',
                    ...(isMobile && {
                      flexDirection: 'column',
                      gap: '2px'
                    })
                  }}
                >
                  <Typography
                    variant={isMobile ? 'xsLight' : 'smLight'}
                    className="main-text"
                    sx={{ textTransform: 'none' }}
                  >
                    Despesa pontual
                  </Typography>
                  <Typography
                    variant="xsLight"
                    color={theme.palette.neutral[400]}
                    sx={{
                      fontSize: '14px',
                      textTransform: 'none',
                      ...(isMobile && {
                        fontSize: '10px',
                        lineHeight: '12px'
                      })
                    }}
                  >
                    (ocorre eventualmente)
                  </Typography>
                </Stack>
              }
            />
          </Tabs>
        )}
      />
    </Box>
  )
}

export default TypeTabs
